import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  updateButton: {
    description: 'One step carrier update submit button',
    defaultMessage: 'Update',
    id: 'Qy5E6/',
  },
});
